// @flow
import React, { Component } from 'react'
import { pick } from 'lodash'
import { message } from 'antd'
import Standards from '../../../components/Main/Standards/Standards'
import StandardApi from '../../../api/Standards'
import Authentication from '../../../modules/Authentication'

type Props = {}
type State = {
  list: Array<any>,
  data: Array<any>,
  fetching: boolean,
  visible: boolean,
  submitting: boolean,
  removing: boolean,
  standard: any,
  type: string,
}

class StandardCont extends Component<Props, State> {
  api = new StandardApi()
  state = {
    list: [],
    data: [],
    fetching: false,
    visible: false,
    submitting: false,
    removing: false,
    standard: {},
    type: 'new',
  }
  auth = new Authentication()
  formRef: { current: null | HTMLFormElement } = React.createRef()

  componentDidMount () {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({ fetching: true })
      let list = await this.api.list()
      this.setState({ data: list, list, fetching: false })
    } catch (err) {
      message.error(err.errorMessage)
      this.setState({ fetching: false })
    }
  }
  onEdit = (standard: any = {}, type: string = 'new') => {
    this.setState({ visible: true, standard, type })
  }
  onCancel = () => {
    this.setState({ visible: false, type: '' })
  }
  submit = async () => {
    const standard = await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      await this.api.create(standard)
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  update = async () => {
    const standard = await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      await this.api.update(standard)
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  checkForm = (): Promise<any> => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          const standard = {
            ...pick(this.state.standard, ['_id', '_rev', '_key']),
            ...values,
          }
          res(standard)
        }
      })
    })
  }
  remove = async () => {
    try {
      this.setState({
        removing: true,
      })
      const { standard } = this.state
      await this.api.remove(pick(standard, ['_id', '_key', '_rev']))
      this.setState({
        removing: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ removing: false })
    }
  }

  render () {
    return (
      <Standards
        {...this.state}
        {...pick(this, [
          'onCancel',
          'onEdit',
          'submit',
          'update',
          'remove',
          'fetch',
          'formRef',
        ])}
      />
    )
  }
}

export default StandardCont
